const bootstrapToTailwind = {

    // ─── Layout ───────────────────────────────────────────────────────────────
    'container':                    'container mx-auto px-4',
    'container-fluid':              'w-full px-4',
    'container-sm':                 'max-w-sm mx-auto px-4',
    'container-md':                 'max-w-md mx-auto px-4',
    'container-lg':                 'max-w-4xl mx-auto px-4',
    'container-xl':                 'max-w-6xl mx-auto px-4',
    'container-xxl':                'max-w-screen-2xl mx-auto px-4',

    // ─── Display ──────────────────────────────────────────────────────────────
    'd-flex':                       'flex',
    'd-inline-flex':                'inline-flex',
    'd-block':                      'block',
    'd-inline':                     'inline',
    'd-inline-block':               'inline-block',
    'd-none':                       'hidden',
    'd-grid':                       'grid',
    'd-table':                      'table',
    'd-table-row':                  'table-row',
    'd-table-cell':                 'table-cell',
    'd-sm-none':                    'sm:hidden',
    'd-sm-flex':                    'sm:flex',
    'd-sm-block':                   'sm:block',
    'd-sm-inline':                  'sm:inline',
    'd-sm-inline-block':            'sm:inline-block',
    'd-md-none':                    'md:hidden',
    'd-md-flex':                    'md:flex',
    'd-md-block':                   'md:block',
    'd-md-inline':                  'md:inline',
    'd-md-inline-block':            'md:inline-block',
    'd-lg-none':                    'lg:hidden',
    'd-lg-flex':                    'lg:flex',
    'd-lg-block':                   'lg:block',
    'd-lg-inline':                  'lg:inline',
    'd-lg-inline-block':            'lg:inline-block',

    // ─── Flexbox ──────────────────────────────────────────────────────────────
    'flex-row':                     'flex-row',
    'flex-column':                  'flex-col',
    'flex-row-reverse':             'flex-row-reverse',
    'flex-column-reverse':          'flex-col-reverse',
    'flex-grow-0':                  'flex-grow-0',
    'flex-grow-1':                  'flex-grow',
    'flex-shrink-0':                'flex-shrink-0',
    'flex-shrink-1':                'flex-shrink',
    'flex-wrap':                    'flex-wrap',
    'flex-nowrap':                  'flex-nowrap',
    'flex-wrap-reverse':            'flex-wrap-reverse',
    'flex-fill':                    'flex-1',
    'justify-content-start':        'justify-start',
    'justify-content-end':          'justify-end',
    'justify-content-center':       'justify-center',
    'justify-content-between':      'justify-between',
    'justify-content-around':       'justify-around',
    'justify-content-evenly':       'justify-evenly',
    'align-items-start':            'items-start',
    'align-items-end':              'items-end',
    'align-items-center':           'items-center',
    'align-items-baseline':         'items-baseline',
    'align-items-stretch':          'items-stretch',
    'align-content-start':          'content-start',
    'align-content-end':            'content-end',
    'align-content-center':         'content-center',
    'align-content-between':        'content-between',
    'align-content-around':         'content-around',
    'align-content-stretch':        'content-stretch',
    'align-self-auto':              'self-auto',
    'align-self-start':             'self-start',
    'align-self-end':               'self-end',
    'align-self-center':            'self-center',
    'align-self-baseline':          'self-baseline',
    'align-self-stretch':           'self-stretch',

    // ─── Order ────────────────────────────────────────────────────────────────
    'order-0':                      'order-none',
    'order-1':                      'order-1',
    'order-2':                      'order-2',
    'order-3':                      'order-3',
    'order-4':                      'order-4',
    'order-5':                      'order-5',
    'order-6':                      'order-6',
    'order-7':                      'order-7',
    'order-8':                      'order-8',
    'order-9':                      'order-9',
    'order-10':                     'order-10',
    'order-11':                     'order-11',
    'order-12':                     'order-12',
    'order-first':                  'order-first',
    'order-last':                   'order-last',

    // ─── Grid Row ─────────────────────────────────────────────────────────────
    'row':                          'flex flex-wrap',
    'row-cols-1':                   'grid grid-cols-1',
    'row-cols-2':                   'grid grid-cols-2',
    'row-cols-3':                   'grid grid-cols-3',
    'row-cols-4':                   'grid grid-cols-4',
    'row-cols-auto':                'grid grid-flow-col auto-cols-auto',
    'g-0':                          'gap-0',
    'g-1':                          'gap-1',
    'g-2':                          'gap-2',
    'g-3':                          'gap-3',
    'g-4':                          'gap-4',
    'g-5':                          'gap-5',
    'gx-0':                         'gap-x-0',
    'gx-1':                         'gap-x-1',
    'gx-2':                         'gap-x-2',
    'gx-3':                         'gap-x-3',
    'gx-4':                         'gap-x-4',
    'gx-5':                         'gap-x-5',
    'gy-0':                         'gap-y-0',
    'gy-1':                         'gap-y-1',
    'gy-2':                         'gap-y-2',
    'gy-3':                         'gap-y-3',
    'gy-4':                         'gap-y-4',
    'gy-5':                         'gap-y-5',

    // ─── Columns (xs) ─────────────────────────────────────────────────────────
    'col':                          'flex-1 px-2',
    'col-auto':                     'w-auto px-2',
    'col-1':                        'w-1/12 px-2',
    'col-2':                        'w-2/12 px-2',
    'col-3':                        'w-3/12 px-2',
    'col-4':                        'w-4/12 px-2',
    'col-5':                        'w-5/12 px-2',
    'col-6':                        'w-6/12 px-2',
    'col-7':                        'w-7/12 px-2',
    'col-8':                        'w-8/12 px-2',
    'col-9':                        'w-9/12 px-2',
    'col-10':                       'w-10/12 px-2',
    'col-11':                       'w-11/12 px-2',
    'col-12':                       'w-full px-2',
    // sm
    'col-sm':                       'sm:flex-1 px-2',
    'col-sm-auto':                  'sm:w-auto px-2',
    'col-sm-1':                     'sm:w-1/12 px-2',
    'col-sm-2':                     'sm:w-2/12 px-2',
    'col-sm-3':                     'sm:w-3/12 px-2',
    'col-sm-4':                     'sm:w-4/12 px-2',
    'col-sm-5':                     'sm:w-5/12 px-2',
    'col-sm-6':                     'sm:w-6/12 px-2',
    'col-sm-7':                     'sm:w-7/12 px-2',
    'col-sm-8':                     'sm:w-8/12 px-2',
    'col-sm-9':                     'sm:w-9/12 px-2',
    'col-sm-10':                    'sm:w-10/12 px-2',
    'col-sm-11':                    'sm:w-11/12 px-2',
    'col-sm-12':                    'sm:w-full px-2',
    // md
    'col-md':                       'md:flex-1 px-2',
    'col-md-auto':                  'md:w-auto px-2',
    'col-md-1':                     'md:w-1/12 px-2',
    'col-md-2':                     'md:w-2/12 px-2',
    'col-md-3':                     'md:w-3/12 px-2',
    'col-md-4':                     'md:w-4/12 px-2',
    'col-md-5':                     'md:w-5/12 px-2',
    'col-md-6':                     'md:w-6/12 px-2',
    'col-md-7':                     'md:w-7/12 px-2',
    'col-md-8':                     'md:w-8/12 px-2',
    'col-md-9':                     'md:w-9/12 px-2',
    'col-md-10':                    'md:w-10/12 px-2',
    'col-md-11':                    'md:w-11/12 px-2',
    'col-md-12':                    'md:w-full px-2',
    // lg
    'col-lg':                       'lg:flex-1 px-2',
    'col-lg-auto':                  'lg:w-auto px-2',
    'col-lg-1':                     'lg:w-1/12 px-2',
    'col-lg-2':                     'lg:w-2/12 px-2',
    'col-lg-3':                     'lg:w-3/12 px-2',
    'col-lg-4':                     'lg:w-4/12 px-2',
    'col-lg-5':                     'lg:w-5/12 px-2',
    'col-lg-6':                     'lg:w-6/12 px-2',
    'col-lg-7':                     'lg:w-7/12 px-2',
    'col-lg-8':                     'lg:w-8/12 px-2',
    'col-lg-9':                     'lg:w-9/12 px-2',
    'col-lg-10':                    'lg:w-10/12 px-2',
    'col-lg-11':                    'lg:w-11/12 px-2',
    'col-lg-12':                    'lg:w-full px-2',
    // xl
    'col-xl':                       'xl:flex-1 px-2',
    'col-xl-auto':                  'xl:w-auto px-2',
    'col-xl-1':                     'xl:w-1/12 px-2',
    'col-xl-2':                     'xl:w-2/12 px-2',
    'col-xl-3':                     'xl:w-3/12 px-2',
    'col-xl-4':                     'xl:w-4/12 px-2',
    'col-xl-5':                     'xl:w-5/12 px-2',
    'col-xl-6':                     'xl:w-6/12 px-2',
    'col-xl-7':                     'xl:w-7/12 px-2',
    'col-xl-8':                     'xl:w-8/12 px-2',
    'col-xl-9':                     'xl:w-9/12 px-2',
    'col-xl-10':                    'xl:w-10/12 px-2',
    'col-xl-11':                    'xl:w-11/12 px-2',
    'col-xl-12':                    'xl:w-full px-2',

    // ─── Offset ───────────────────────────────────────────────────────────────
    'offset-1':                     'ml-1/12',
    'offset-2':                     'ml-2/12',
    'offset-3':                     'ml-3/12',
    'offset-4':                     'ml-4/12',
    'offset-5':                     'ml-5/12',
    'offset-6':                     'ml-6/12',
    'offset-md-1':                  'md:ml-1/12',
    'offset-md-2':                  'md:ml-2/12',
    'offset-md-3':                  'md:ml-3/12',
    'offset-md-4':                  'md:ml-4/12',
    'offset-md-6':                  'md:ml-6/12',
    'offset-lg-1':                  'lg:ml-1/12',
    'offset-lg-2':                  'lg:ml-2/12',
    'offset-lg-3':                  'lg:ml-3/12',
    'offset-lg-4':                  'lg:ml-4/12',
    'offset-lg-6':                  'lg:ml-6/12',

    // ─── Typography ───────────────────────────────────────────────────────────
    'h1':                           'text-5xl font-bold',
    'h2':                           'text-4xl font-bold',
    'h3':                           'text-3xl font-bold',
    'h4':                           'text-2xl font-bold',
    'h5':                           'text-xl font-bold',
    'h6':                           'text-lg font-bold',
    'display-1':                    'text-8xl font-light',
    'display-2':                    'text-7xl font-light',
    'display-3':                    'text-6xl font-light',
    'display-4':                    'text-5xl font-light',
    'display-5':                    'text-4xl font-light',
    'display-6':                    'text-3xl font-light',
    'lead':                         'text-xl font-light leading-relaxed',
    'small':                        'text-sm',
    'mark':                         'bg-yellow-200 px-1',
    'blockquote':                   'pl-4 border-l-4 border-gray-300 italic',
    'text-left':                    'text-left',
    'text-center':                  'text-center',
    'text-right':                   'text-right',
    'text-justify':                 'text-justify',
    'text-start':                   'text-left',
    'text-end':                     'text-right',
    'text-lowercase':               'lowercase',
    'text-uppercase':               'uppercase',
    'text-capitalize':              'capitalize',
    'text-wrap':                    'whitespace-normal',
    'text-nowrap':                  'whitespace-nowrap',
    'text-break':                   'break-words',
    'text-truncate':                'truncate',
    'text-decoration-none':         'no-underline',
    'text-decoration-underline':    'underline',
    'text-decoration-line-through': 'line-through',
    'text-reset':                   'text-inherit',
    // ✅ FIXED: these were wrongly mapped to letter-spacing; Bootstrap text-sm/lg = font size
    'text-sm':                      'text-sm',
    'text-base':                    'text-base',
    'text-lg':                      'text-lg',
    'text-xl':                      'text-xl',
    'font-weight-bold':             'font-bold',
    'font-weight-bolder':           'font-extrabold',
    'font-weight-normal':           'font-normal',
    'font-weight-light':            'font-light',
    'font-weight-lighter':          'font-thin',
    'font-italic':                  'italic',
    'fst-italic':                   'italic',
    'fst-normal':                   'not-italic',
    'fw-bold':                      'font-bold',
    'fw-bolder':                    'font-extrabold',
    'fw-normal':                    'font-normal',
    'fw-light':                     'font-light',
    'fw-lighter':                   'font-thin',
    'fw-semibold':                  'font-semibold',
    'fw-medium':                    'font-medium',
    'text-monospace':               'font-mono',
    'font-monospace':               'font-mono',
    'lh-1':                         'leading-none',
    'lh-sm':                        'leading-tight',
    'lh-base':                      'leading-normal',
    'lh-lg':                        'leading-loose',
    'fs-1':                         'text-5xl',
    'fs-2':                         'text-4xl',
    'fs-3':                         'text-3xl',
    'fs-4':                         'text-2xl',
    'fs-5':                         'text-xl',
    'fs-6':                         'text-base',

    // ─── Spacing — Margin ─────────────────────────────────────────────────────
    'm-0': 'm-0', 'm-1': 'm-1', 'm-2': 'm-2', 'm-3': 'm-3', 'm-4': 'm-4', 'm-5': 'm-5', 'm-auto': 'm-auto',
    'mt-0': 'mt-0', 'mt-1': 'mt-1', 'mt-2': 'mt-2', 'mt-3': 'mt-3', 'mt-4': 'mt-4', 'mt-5': 'mt-5', 'mt-auto': 'mt-auto',
    'mb-0': 'mb-0', 'mb-1': 'mb-1', 'mb-2': 'mb-2', 'mb-3': 'mb-3', 'mb-4': 'mb-4', 'mb-5': 'mb-5', 'mb-auto': 'mb-auto',
    'ml-0': 'ml-0', 'ml-1': 'ml-1', 'ml-2': 'ml-2', 'ml-3': 'ml-3', 'ml-4': 'ml-4', 'ml-5': 'ml-5', 'ml-auto': 'ml-auto',
    'mr-0': 'mr-0', 'mr-1': 'mr-1', 'mr-2': 'mr-2', 'mr-3': 'mr-3', 'mr-4': 'mr-4', 'mr-5': 'mr-5', 'mr-auto': 'mr-auto',
    'mx-0': 'mx-0', 'mx-1': 'mx-1', 'mx-2': 'mx-2', 'mx-3': 'mx-3', 'mx-4': 'mx-4', 'mx-5': 'mx-5', 'mx-auto': 'mx-auto',
    'my-0': 'my-0', 'my-1': 'my-1', 'my-2': 'my-2', 'my-3': 'my-3', 'my-4': 'my-4', 'my-5': 'my-5', 'my-auto': 'my-auto',
    // Bootstrap 5 logical margins
    'ms-0': 'ml-0', 'ms-1': 'ml-1', 'ms-2': 'ml-2', 'ms-3': 'ml-3', 'ms-4': 'ml-4', 'ms-5': 'ml-5', 'ms-auto': 'ml-auto',
    'me-0': 'mr-0', 'me-1': 'mr-1', 'me-2': 'mr-2', 'me-3': 'mr-3', 'me-4': 'mr-4', 'me-5': 'mr-5', 'me-auto': 'mr-auto',

    // ─── Spacing — Padding ────────────────────────────────────────────────────
    'p-0': 'p-0', 'p-1': 'p-1', 'p-2': 'p-2', 'p-3': 'p-3', 'p-4': 'p-4', 'p-5': 'p-5',
    'pt-0': 'pt-0', 'pt-1': 'pt-1', 'pt-2': 'pt-2', 'pt-3': 'pt-3', 'pt-4': 'pt-4', 'pt-5': 'pt-5',
    'pb-0': 'pb-0', 'pb-1': 'pb-1', 'pb-2': 'pb-2', 'pb-3': 'pb-3', 'pb-4': 'pb-4', 'pb-5': 'pb-5',
    'pl-0': 'pl-0', 'pl-1': 'pl-1', 'pl-2': 'pl-2', 'pl-3': 'pl-3', 'pl-4': 'pl-4', 'pl-5': 'pl-5',
    'pr-0': 'pr-0', 'pr-1': 'pr-1', 'pr-2': 'pr-2', 'pr-3': 'pr-3', 'pr-4': 'pr-4', 'pr-5': 'pr-5',
    'px-0': 'px-0', 'px-1': 'px-1', 'px-2': 'px-2', 'px-3': 'px-3', 'px-4': 'px-4', 'px-5': 'px-5',
    'py-0': 'py-0', 'py-1': 'py-1', 'py-2': 'py-2', 'py-3': 'py-3', 'py-4': 'py-4', 'py-5': 'py-5',
    // Bootstrap 5 logical padding
    'ps-0': 'pl-0', 'ps-1': 'pl-1', 'ps-2': 'pl-2', 'ps-3': 'pl-3', 'ps-4': 'pl-4', 'ps-5': 'pl-5',
    'pe-0': 'pr-0', 'pe-1': 'pr-1', 'pe-2': 'pr-2', 'pe-3': 'pr-3', 'pe-4': 'pr-4', 'pe-5': 'pr-5',

    // ─── Sizing ───────────────────────────────────────────────────────────────
    'w-25':                         'w-1/4',
    'w-50':                         'w-1/2',
    'w-75':                         'w-3/4',
    'w-100':                        'w-full',
    'w-auto':                       'w-auto',
    'h-25':                         'h-1/4',
    'h-50':                         'h-1/2',
    'h-75':                         'h-3/4',
    'h-100':                        'h-full',
    'h-auto':                       'h-auto',
    'mw-100':                       'max-w-full',
    'mh-100':                       'max-h-full',
    'min-vw-100':                   'min-w-screen',
    'min-vh-100':                   'min-h-screen',
    'vw-100':                       'w-screen',
    'vh-100':                       'h-screen',

    // ─── Visibility ───────────────────────────────────────────────────────────
    'visible':                      'visible',
    'invisible':                    'invisible',

    // ─── Overflow ─────────────────────────────────────────────────────────────
    'overflow-auto':                'overflow-auto',
    'overflow-hidden':              'overflow-hidden',
    'overflow-visible':             'overflow-visible',
    'overflow-scroll':              'overflow-scroll',

    // ─── Position ─────────────────────────────────────────────────────────────
    'position-static':              'static',
    'position-relative':            'relative',
    'position-absolute':            'absolute',
    'position-fixed':               'fixed',
    'position-sticky':              'sticky',
    'top-0':                        'top-0',
    'top-50':                       'top-1/2',
    'top-100':                      'top-full',
    'bottom-0':                     'bottom-0',
    'bottom-50':                    'bottom-1/2',
    'bottom-100':                   'bottom-full',
    'start-0':                      'left-0',
    'start-50':                     'left-1/2',
    'start-100':                    'left-full',
    'end-0':                        'right-0',
    'end-50':                       'right-1/2',
    'end-100':                      'right-full',
    'left-0':                       'left-0',
    'right-0':                      'right-0',
    'translate-middle':             '-translate-x-1/2 -translate-y-1/2',
    'translate-middle-x':           '-translate-x-1/2',
    'translate-middle-y':           '-translate-y-1/2',
    'fixed-top':                    'fixed top-0 left-0 right-0 z-50',
    'fixed-bottom':                 'fixed bottom-0 left-0 right-0 z-50',
    'sticky-top':                   'sticky top-0 z-40',

    // ─── Z-Index ──────────────────────────────────────────────────────────────
    'z-0':                          'z-0',
    'z-1':                          'z-10',
    'z-2':                          'z-20',
    'z-3':                          'z-30',

    // ─── Shadows ──────────────────────────────────────────────────────────────
    'shadow-none':                  'shadow-none',
    'shadow-sm':                    'shadow-sm',
    'shadow':                       'shadow',
    'shadow-lg':                    'shadow-lg',

    // ─── Borders ──────────────────────────────────────────────────────────────
    'border':                       'border border-gray-300',
    'border-0':                     'border-0',
    'border-top':                   'border-t border-gray-300',
    'border-top-0':                 'border-t-0',
    'border-end':                   'border-r border-gray-300',
    'border-end-0':                 'border-r-0',
    'border-bottom':                'border-b border-gray-300',
    'border-bottom-0':              'border-b-0',
    'border-start':                 'border-l border-gray-300',
    'border-start-0':               'border-l-0',
    'border-right':                 'border-r border-gray-300',
    'border-right-0':               'border-r-0',
    'border-left':                  'border-l border-gray-300',
    'border-left-0':                'border-l-0',
    'border-primary':               'border-blue-500',
    'border-secondary':             'border-gray-500',
    'border-success':               'border-green-500',
    'border-danger':                'border-red-500',
    'border-warning':               'border-yellow-500',
    'border-info':                  'border-teal-500',
    'border-light':                 'border-gray-200',
    'border-dark':                  'border-gray-800',
    'border-white':                 'border-white',
    'border-1':                     'border',
    'border-2':                     'border-2',
    'border-3':                     'border-4',
    'rounded-0':                    'rounded-none',
    'rounded':                      'rounded',
    'rounded-1':                    'rounded-sm',
    'rounded-2':                    'rounded',
    'rounded-3':                    'rounded-lg',
    'rounded-sm':                   'rounded-sm',
    'rounded-lg':                   'rounded-lg',
    'rounded-circle':               'rounded-full',
    'rounded-pill':                 'rounded-full',
    'rounded-top':                  'rounded-t',
    'rounded-end':                  'rounded-r',
    'rounded-bottom':               'rounded-b',
    'rounded-start':                'rounded-l',

    // ─── Floats ───────────────────────────────────────────────────────────────
    'float-start':                  'float-left',
    'float-end':                    'float-right',
    'float-none':                   'float-none',
    'float-left':                   'float-left',
    'float-right':                  'float-right',
    'clearfix':                     'clearfix',

    // ─── Opacity ──────────────────────────────────────────────────────────────
    'opacity-0':                    'opacity-0',
    'opacity-25':                   'opacity-25',
    'opacity-50':                   'opacity-50',
    'opacity-75':                   'opacity-75',
    'opacity-100':                  'opacity-100',

    // ─── Colors — Background ──────────────────────────────────────────────────
    'bg-primary':                   'bg-blue-600',
    'bg-secondary':                 'bg-gray-500',
    'bg-success':                   'bg-green-500',
    'bg-danger':                    'bg-red-500',
    'bg-warning':                   'bg-yellow-400',
    'bg-info':                      'bg-cyan-500',
    'bg-light':                     'bg-gray-100',
    'bg-dark':                      'bg-gray-900',
    'bg-white':                     'bg-white',
    'bg-transparent':               'bg-transparent',
    'bg-body':                      'bg-white',
    'bg-gradient':                  'bg-gradient-to-r',
    'bg-black':                     'bg-black',

    // ─── Colors — Text ────────────────────────────────────────────────────────
    'text-primary':                 'text-blue-600',
    'text-secondary':               'text-gray-500',
    'text-success':                 'text-green-600',
    'text-danger':                  'text-red-600',
    'text-warning':                 'text-yellow-500',
    'text-info':                    'text-cyan-600',
    'text-light':                   'text-gray-300',
    'text-dark':                    'text-gray-900',
    'text-white':                   'text-white',
    'text-muted':                   'text-gray-500',
    'text-black-50':                'text-black/50',
    'text-white-50':                'text-white/50',
    'text-body':                    'text-gray-900',

    // ─── Buttons ──────────────────────────────────────────────────────────────
    'btn':                          'inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm cursor-pointer transition-colors duration-150',
    'btn-primary':                  'bg-blue-600 hover:bg-blue-700 text-white border-blue-600',
    'btn-secondary':                'bg-gray-500 hover:bg-gray-600 text-white border-gray-500',
    'btn-success':                  'bg-green-500 hover:bg-green-600 text-white border-green-500',
    'btn-danger':                   'bg-red-500 hover:bg-red-600 text-white border-red-500',
    'btn-warning':                  'bg-yellow-400 hover:bg-yellow-500 text-gray-900 border-yellow-400',
    'btn-info':                     'bg-cyan-500 hover:bg-cyan-600 text-white border-cyan-500',
    'btn-light':                    'bg-gray-100 hover:bg-gray-200 text-gray-900 border-gray-200',
    'btn-dark':                     'bg-gray-900 hover:bg-black text-white border-gray-900',
    'btn-link':                     'bg-transparent text-blue-600 hover:underline border-transparent shadow-none',
    'btn-outline-primary':          'bg-transparent text-blue-600 border border-blue-600 hover:bg-blue-600 hover:text-white',
    'btn-outline-secondary':        'bg-transparent text-gray-600 border border-gray-500 hover:bg-gray-500 hover:text-white',
    'btn-outline-success':          'bg-transparent text-green-600 border border-green-500 hover:bg-green-500 hover:text-white',
    'btn-outline-danger':           'bg-transparent text-red-600 border border-red-500 hover:bg-red-500 hover:text-white',
    'btn-outline-warning':          'bg-transparent text-yellow-600 border border-yellow-400 hover:bg-yellow-400 hover:text-white',
    'btn-outline-info':             'bg-transparent text-cyan-600 border border-cyan-500 hover:bg-cyan-500 hover:text-white',
    'btn-outline-light':            'bg-transparent text-gray-600 border border-gray-200 hover:bg-gray-100',
    'btn-outline-dark':             'bg-transparent text-gray-900 border border-gray-800 hover:bg-gray-900 hover:text-white',
    'btn-sm':                       'px-2 py-1 text-xs rounded',
    'btn-lg':                       'px-6 py-3 text-lg rounded-lg',
    'btn-block':                    'w-full flex',
    'btn-close':                    'text-gray-500 hover:text-gray-700 text-lg font-bold',
    'btn-group':                    'inline-flex',
    'btn-group-sm':                 'inline-flex',
    'btn-group-lg':                 'inline-flex',
    'btn-group-vertical':           'inline-flex flex-col',

    // ─── Cards ────────────────────────────────────────────────────────────────
    'card':                         'bg-white rounded-lg shadow border border-gray-200 overflow-hidden',
    'card-body':                    'p-6',
    'card-title':                   'text-xl font-semibold text-gray-900 mb-2',
    'card-subtitle':                'text-sm text-gray-500 mb-2',
    'card-text':                    'text-gray-700',
    'card-link':                    'text-blue-600 hover:underline',
    'card-header':                  'px-6 py-3 bg-gray-50 border-b border-gray-200 font-semibold',
    'card-footer':                  'px-6 py-3 bg-gray-50 border-t border-gray-200',
    'card-img':                     'w-full object-cover',
    'card-img-top':                 'w-full object-cover rounded-t-lg',
    'card-img-bottom':              'w-full object-cover rounded-b-lg',
    'card-img-overlay':             'absolute inset-0 p-6',
    'card-group':                   'flex flex-wrap gap-4',
    'card-deck':                    'flex flex-wrap gap-4',
    'card-columns':                 'columns-3 gap-4',

    // ─── Alerts ───────────────────────────────────────────────────────────────
    'alert':                        'px-4 py-3 rounded-lg border mb-4',
    'alert-primary':                'bg-blue-50 border-blue-200 text-blue-800',
    'alert-secondary':              'bg-gray-50 border-gray-200 text-gray-800',
    'alert-success':                'bg-green-50 border-green-200 text-green-800',
    'alert-danger':                 'bg-red-50 border-red-200 text-red-800',
    'alert-warning':                'bg-yellow-50 border-yellow-200 text-yellow-800',
    'alert-info':                   'bg-cyan-50 border-cyan-200 text-cyan-800',
    'alert-light':                  'bg-gray-50 border-gray-100 text-gray-700',
    'alert-dark':                   'bg-gray-800 border-gray-700 text-gray-100',
    'alert-dismissible':            'relative pr-10',
    'alert-heading':                'font-bold text-lg mb-1',
    'alert-link':                   'font-bold underline',

    // ─── Badges ───────────────────────────────────────────────────────────────
    'badge':                        'inline-flex items-center px-2.5 py-0.5 rounded text-xs font-semibold',
    'bg-pill':                      'rounded-full',
    'badge-primary':                'bg-blue-600 text-white',
    'badge-secondary':              'bg-gray-500 text-white',
    'badge-success':                'bg-green-500 text-white',
    'badge-danger':                 'bg-red-500 text-white',
    'badge-warning':                'bg-yellow-400 text-gray-900',
    'badge-info':                   'bg-cyan-500 text-white',
    'badge-light':                  'bg-gray-100 text-gray-900',
    'badge-dark':                   'bg-gray-900 text-white',
    'rounded-pill badge':           'rounded-full px-2.5 py-0.5 text-xs font-semibold',

    // ─── Navbar ───────────────────────────────────────────────────────────────
    'navbar':                       'flex items-center px-4 py-2 w-full',
    'navbar-brand':                 'text-xl font-bold mr-4',
    'navbar-nav':                   'flex items-center space-x-2',
    'navbar-toggler':               'p-2 rounded border border-gray-300 md:hidden',
    'navbar-collapse':              'flex-grow items-center',
    'navbar-expand':                'flex flex-wrap items-center',
    'navbar-expand-sm':             'sm:flex sm:flex-wrap sm:items-center',
    'navbar-expand-md':             'md:flex md:flex-wrap md:items-center',
    'navbar-expand-lg':             'lg:flex lg:flex-wrap lg:items-center',
    'navbar-expand-xl':             'xl:flex xl:flex-wrap xl:items-center',
    'navbar-dark':                  'bg-gray-900 text-white',
    'navbar-light':                 'bg-white text-gray-900',
    'nav-item':                     'list-none',
    'nav-link':                     'px-3 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 rounded-md transition-colors',
    'nav-link active':              'text-blue-600 font-semibold',
    'nav-tabs':                     'flex border-b border-gray-200',
    'nav-pills':                    'flex space-x-1',

    // ─── Forms ────────────────────────────────────────────────────────────────
    'form-control':                 'w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm',
    'form-control-sm':              'w-full px-2 py-1 text-sm border border-gray-300 rounded',
    'form-control-lg':              'w-full px-4 py-3 text-lg border border-gray-300 rounded-lg',
    'form-control-plaintext':       'w-full px-3 py-2 bg-transparent border-0',
    'form-select':                  'w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white',
    'form-select-sm':               'w-full px-2 py-1 text-sm border border-gray-300 rounded',
    'form-select-lg':               'w-full px-4 py-3 text-lg border border-gray-300 rounded-lg',
    'form-check':                   'flex items-start gap-2 py-1',
    'form-check-input':             'w-4 h-4 mt-0.5 border border-gray-300 rounded text-blue-600',
    'form-check-label':             'text-sm text-gray-700',
    'form-check-inline':            'inline-flex items-center gap-2 mr-4',
    'form-label':                   'block text-sm font-medium text-gray-700 mb-1',
    'form-text':                    'text-sm text-gray-500 mt-1',
    'form-floating':                'relative',
    'form-range':                   'w-full h-2 accent-blue-600',
    'form-group':                   'mb-4',
    'form-inline':                  'flex flex-wrap items-center gap-2',
    'form-row':                     'flex flex-wrap gap-4',
    'was-validated':                '',
    'needs-validation':             '',
    'is-valid':                     'border-green-500 focus:ring-green-500',
    'is-invalid':                   'border-red-500 focus:ring-red-500',
    'valid-feedback':               'text-sm text-green-600 mt-1',
    'invalid-feedback':             'text-sm text-red-600 mt-1',
    'input-group':                  'flex items-stretch',
    'input-group-text':             'px-3 py-2 bg-gray-100 border border-gray-300 text-sm text-gray-700',
    'input-group-sm':               'flex items-stretch text-sm',
    'input-group-lg':               'flex items-stretch text-lg',
    'input-group-prepend':          'flex items-center',
    'input-group-append':           'flex items-center',

    // ─── Tables ───────────────────────────────────────────────────────────────
    'table':                        'w-full border-collapse text-sm',
    'table-striped':                '[&>tbody>tr:nth-child(odd)]:bg-gray-50',
    'table-bordered':               'border border-gray-200 [&_th]:border [&_td]:border [&_th]:border-gray-200 [&_td]:border-gray-200',
    'table-borderless':             '[&_th]:border-0 [&_td]:border-0',
    'table-hover':                  '[&>tbody>tr:hover]:bg-gray-100',
    'table-sm':                     '[&_th]:px-2 [&_th]:py-1 [&_td]:px-2 [&_td]:py-1',
    'table-dark':                   'bg-gray-900 text-white [&_thead]:bg-gray-800',
    'table-responsive':             'overflow-x-auto',
    'thead-dark':                   'bg-gray-800 text-white',
    'thead-light':                  'bg-gray-100 text-gray-700',
    'table-active':                 'bg-blue-50',
    'table-primary':                'bg-blue-50',
    'table-secondary':              'bg-gray-50',
    'table-success':                'bg-green-50',
    'table-danger':                 'bg-red-50',
    'table-warning':                'bg-yellow-50',
    'table-info':                   'bg-cyan-50',
    'table-light':                  'bg-gray-50',

    // ─── Modals ───────────────────────────────────────────────────────────────
    'modal':                        'fixed inset-0 z-50 flex items-center justify-center overflow-y-auto',
    'modal-dialog':                 'relative w-full max-w-lg mx-auto my-8',
    'modal-dialog-centered':        'relative w-full max-w-lg mx-auto',
    'modal-content':                'bg-white rounded-lg shadow-xl overflow-hidden',
    'modal-header':                 'flex items-center justify-between px-6 py-4 border-b border-gray-200',
    'modal-title':                  'text-xl font-semibold text-gray-900',
    'modal-body':                   'px-6 py-4',
    'modal-footer':                 'flex items-center justify-end px-6 py-4 border-t border-gray-200 gap-2',
    'modal-backdrop':               'fixed inset-0 bg-black bg-opacity-50 z-40',
    'modal-sm':                     'max-w-sm',
    'modal-lg':                     'max-w-2xl',
    'modal-xl':                     'max-w-4xl',
    'modal-fullscreen':             'max-w-full m-0 h-full',

    // ─── List Groups ──────────────────────────────────────────────────────────
    'list-group':                   'flex flex-col rounded-lg border border-gray-200 overflow-hidden',
    'list-group-flush':             'flex flex-col divide-y divide-gray-200',
    'list-group-item':              'px-4 py-3 bg-white text-gray-900 border-b border-gray-200 last:border-0',
    'list-group-item-action':       'px-4 py-3 bg-white text-gray-900 hover:bg-gray-50 cursor-pointer transition-colors',
    'list-group-item-primary':      'bg-blue-50 text-blue-800',
    'list-group-item-secondary':    'bg-gray-50 text-gray-800',
    'list-group-item-success':      'bg-green-50 text-green-800',
    'list-group-item-danger':       'bg-red-50 text-red-800',
    'list-group-item-warning':      'bg-yellow-50 text-yellow-800',
    'list-group-item-info':         'bg-cyan-50 text-cyan-800',

    // ─── Dropdowns ────────────────────────────────────────────────────────────
    'dropdown':                     'relative inline-block',
    'dropdown-toggle':              'inline-flex items-center gap-1 cursor-pointer',
    'dropdown-menu':                'absolute z-50 mt-1 min-w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1',
    'dropdown-item':                'block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer',
    'dropdown-divider':             'border-t border-gray-200 my-1',
    'dropdown-header':              'px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide',
    'dropdown-menu-end':            'right-0',
    'dropdown-menu-start':          'left-0',
    'dropdown-menu-dark':           'bg-gray-900 border-gray-700 [&_.dropdown-item]:text-gray-300',
    'dropup':                       'relative inline-block',
    'dropend':                      'relative inline-block',
    'dropstart':                    'relative inline-block',

    // ─── Accordion ────────────────────────────────────────────────────────────
    'accordion':                    'border border-gray-200 rounded-lg divide-y divide-gray-200',
    'accordion-item':               'bg-white',
    'accordion-header':             'flex',
    'accordion-button':             'flex flex-1 items-center justify-between px-4 py-3 font-medium text-gray-900 bg-white cursor-pointer hover:bg-gray-50',
    'accordion-collapse':           'overflow-hidden',
    'accordion-body':               'px-4 py-3 text-gray-700',

    // ─── Progress ─────────────────────────────────────────────────────────────
    'progress':                     'w-full bg-gray-200 rounded-full overflow-hidden',
    'progress-bar':                 'bg-blue-600 h-4 rounded-full transition-all',
    'progress-bar-striped':         'bg-stripes',
    'progress-bar-animated':        'animate-pulse',

    // ─── Spinners ─────────────────────────────────────────────────────────────
    'spinner-border':               'inline-block w-8 h-8 border-4 border-current border-t-transparent rounded-full animate-spin',
    'spinner-border-sm':            'inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin',
    'spinner-grow':                 'inline-block w-8 h-8 bg-current rounded-full animate-ping',
    'spinner-grow-sm':              'inline-block w-4 h-4 bg-current rounded-full animate-ping',

    // ─── Pagination ───────────────────────────────────────────────────────────
    'pagination':                   'flex list-none items-center gap-1',
    'page-item':                    'list-none',
    'page-link':                    'px-3 py-2 text-sm rounded border border-gray-300 text-blue-600 hover:bg-gray-100 cursor-pointer',
    'page-item disabled':           'pointer-events-none opacity-50',
    'page-item active':             '',
    'pagination-sm':                'flex list-none items-center gap-0.5',
    'pagination-lg':                'flex list-none items-center gap-2',

    // ─── Breadcrumbs ──────────────────────────────────────────────────────────
    'breadcrumb':                   'flex flex-wrap items-center list-none gap-1 text-sm text-gray-500',
    'breadcrumb-item':              'flex items-center',

    // ─── Tooltips & Popovers ──────────────────────────────────────────────────
    'tooltip':                      'absolute z-50 px-2 py-1 text-xs text-white bg-gray-900 rounded shadow',
    'tooltip-inner':                'max-w-xs text-center',
    'popover':                      'absolute z-50 bg-white border border-gray-200 rounded-lg shadow-lg max-w-xs',
    'popover-header':               'px-4 py-2 bg-gray-50 border-b border-gray-200 font-semibold rounded-t-lg',
    'popover-body':                 'px-4 py-3 text-sm text-gray-700',

    // ─── Toast ────────────────────────────────────────────────────────────────
    'toast':                        'flex flex-col bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden max-w-sm',
    'toast-header':                 'flex items-center px-3 py-2 bg-gray-50 border-b border-gray-200 text-sm font-medium',
    'toast-body':                   'px-3 py-2 text-sm text-gray-700',
    'toast-container':              'fixed z-50 p-4 flex flex-col gap-2',

    // ─── Utilities ────────────────────────────────────────────────────────────
    'stretched-link':               'after:absolute after:inset-0',
    'img-fluid':                    'max-w-full h-auto',
    'img-thumbnail':                'p-1 bg-white border border-gray-200 rounded max-w-full h-auto',
    'figure':                       'inline-block',
    'figure-img':                   'max-w-full h-auto rounded',
    'figure-caption':               'text-sm text-gray-500 mt-1',
    'sr-only':                      'sr-only',
    'visually-hidden':              'sr-only',
    'visually-hidden-focusable':    'sr-only focus:not-sr-only',
    'initialism':                   'uppercase tracking-wide text-sm',
    'blockquote-footer':            'text-sm text-gray-500',
    'embed-responsive':             'relative overflow-hidden',
    'embed-responsive-16by9':       'aspect-video',
    'embed-responsive-4by3':        'aspect-4/3',
    'ratio':                        'relative',
    'ratio-1x1':                    'aspect-square',
    'ratio-4x3':                    'aspect-4/3',
    'ratio-16x9':                   'aspect-video',
    'ratio-21x9':                   'aspect-21/9',
    'object-fit-contain':           'object-contain',
    'object-fit-cover':             'object-cover',
    'object-fit-fill':              'object-fill',
    'object-fit-scale':             'object-scale-down',
    'object-fit-none':              'object-none',
    'text-bg-primary':              'bg-blue-600 text-white',
    'text-bg-secondary':            'bg-gray-500 text-white',
    'text-bg-success':              'bg-green-500 text-white',
    'text-bg-danger':               'bg-red-500 text-white',
    'text-bg-warning':              'bg-yellow-400 text-gray-900',
    'text-bg-info':                 'bg-cyan-500 text-white',
    'text-bg-light':                'bg-gray-100 text-gray-900',
    'text-bg-dark':                 'bg-gray-900 text-white',

    // ─── Spacing Helpers ──────────────────────────────────────────────────────
    'gap-0': 'gap-0', 'gap-1': 'gap-1', 'gap-2': 'gap-2',
    'gap-3': 'gap-3', 'gap-4': 'gap-4', 'gap-5': 'gap-5',
};

export default bootstrapToTailwind;